import { render, staticRenderFns } from "./QuestionandAnswers.vue?vue&type=template&id=7642150e&scoped=true"
import script from "./QuestionandAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionandAnswers.vue?vue&type=script&lang=js"
import style0 from "./QuestionandAnswers.vue?vue&type=style&index=0&id=7642150e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642150e",
  null
  
)

export default component.exports